import { useCallback } from 'react'

const useTestAttribute = dataTest => {
  const testAttr = useCallback(
    (index, type) => `${dataTest}-option-${index}-${type}`,
    [dataTest]
  )

  return testAttr
}

export default useTestAttribute
